import { render, staticRenderFns } from "./OrganizationEditPage.vue?vue&type=template&id=6d10aa68&scoped=true&"
import script from "./OrganizationEditPage.vue?vue&type=script&lang=ts&"
export * from "./OrganizationEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationEditPage.vue?vue&type=style&index=0&id=6d10aa68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10aa68",
  null
  
)

export default component.exports